export const GET_ACTION_DETAILS = "GET_ACTION_DETAILS";
export const GET_ACTION_EDIT = "GET_ACTION_EDIT";
export const GET_ACTION_FILTER_DATA = "GET_ACTION_FILTER_DATA";
export const GET_ACTION_LIST_DATA = "GET_ACTION_LIST_DATA";
